import React from 'react';
import PropTypes from 'prop-types';
import { LOAD_MORE_STRING } from '../../../../constants';
import buildPaginationUrl from '../../helpers/build-pagination-url';
import BlazeLink from '../../../BlazeLink';
const LoadMore = ({
  name,
  currentPage,
  query,
  url,
  triggerInfiniteScroll,
  isLastPage
}) => {
  if (isLastPage) return null;
  const nextPage = currentPage + 1;
  const nextPageLink = buildPaginationUrl(name, nextPage, query, url);
  const loadMoreItems = e => {
    e.preventDefault();
    triggerInfiniteScroll();
  };
  return /*#__PURE__*/React.createElement(BlazeLink, {
    className: "pagination_load-more",
    role: "button",
    href: nextPageLink,
    onClick: loadMoreItems
  }, LOAD_MORE_STRING);
};
LoadMore.propTypes = {
  isLastPage: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  triggerInfiniteScroll: PropTypes.func.isRequired
};
export default LoadMore;
//# sourceMappingURL=LoadMore.js.map